import sharedApi from './SharedApi.js';
import { FY } from '../components/shared/Utils';

class DashboardApi {

    async getFiscalYears(onError) {
        let fiscalYears = await sharedApi.get('/api/grant/retrieveFiscalYears', onError);
        fiscalYears.push(FY.ALL);
        fiscalYears.push(FY.ACTIVE);

        return fiscalYears;
    }
}

export default new DashboardApi();
